import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
function useForwardedReference(forwardedReference) {
    const innerReference = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if ('function' == typeof forwardedReference) forwardedReference(innerReference.current);
        else if (null !== forwardedReference) forwardedReference.current = innerReference.current;
    }, [
        forwardedReference
    ]);
    return innerReference;
}
export { useForwardedReference as useForwardedRef };

//# sourceMappingURL=use-forwarded-ref.js.map